import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import { Link } from "react-router-dom";

import PriceList    from './PriceList'
import Quantity     from './Quantity'
import Filter       from './Filter'

import { ReactComponent as Home } from '../svg/home.svg';
import { ReactComponent as List } from '../svg/list.svg';

@inject('core')
@observer
export default class Header extends React.Component {
	
	constructor(props) {
		super(props)
		this.vaributtonClick = this.vaributtonClick.bind(this)
	}
	
	componentDidMount() {
		const { core } = this.props
		
	}
	
	vaributtonClick() {
		const { core, path } = this.props
		if (path == '/:pod_id/') {
			core.updateProductFilter('')
		}
	}

	render() {
		const { core, path } = this.props
		
		var vaributton = <Link to={"/" + core.pod_id} id="home-button" className="clickable" onClick={this.vaributtonClick}><Home /></Link>
		
		switch(path) {				
			case '/:pod_id/':
				return <div id="header">
					{vaributton}
					<Filter />
					<Link to={'/' + core.pod_id + "/stores"} id="stores-button" title={core.stores.length + ' Stores'}><List /> { core.stores.length }</Link>
				</div>
				break;

				
			default:
				return <div id="header">
					{vaributton}
				</div>

		}			
	}
	
}


